import { render } from "./TopTrendTemplate.vue?vue&type=template&id=59ea5112&scoped=true"
import script from "./TopTrendTemplate.vue?vue&type=script&lang=js"
export * from "./TopTrendTemplate.vue?vue&type=script&lang=js"

import "./TopTrendTemplate.vue?vue&type=style&index=0&id=59ea5112&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59ea5112"

export default script